import { render, staticRenderFns } from "./EmailInputV1Properties.vue?vue&type=template&id=07f8c607&"
import script from "./EmailInputV1Properties.vue?vue&type=script&lang=js&"
export * from "./EmailInputV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports